import { GET_BSTATS } from '../types';

const defaultStats = {
  todayMillis: 0,
  weekMillis:  0
}

export default function(stats = defaultStats, action) {
  switch (action.type) {
    case GET_BSTATS:
      return {
        todayMillis: action.stats.todayMillis,
        weekMillis: action.stats.weekMillis,
      };
    default:
      return stats;
  }
}